export class OptionType {
    value: string;
    description: string;

    // only for surcharges
    checked: boolean;
    order?: number | string;
    type?: SurchargeType;
}

export type SurchargeType = 'PRIMARY' | 'CORE' | 'DEFAULT';
